import { ListingStatus } from '@/domain/units';
import type { FC } from 'react';

interface TagConfig {
  text: string;
  bgColor: string;
}

const TAG_CONFIG: Partial<Record<ListingStatus, TagConfig>> = {
  [ListingStatus.ACTIVE]: {
    text: 'Available',
    bgColor: 'bg-sage-600',
  },
  [ListingStatus.COMING_SOON]: {
    text: 'Coming Soon',
    bgColor: 'bg-gray-600',
  },
};

interface Props {
  unitListingStatus: ListingStatus | undefined;
  className?: string;
}

const UnitAvailableTag: FC<Props> = ({ unitListingStatus, className }) => {
  const config = unitListingStatus ? TAG_CONFIG[unitListingStatus] : undefined;

  if (!config) {
    return null;
  }

  return (
    <span
      className={` text-white px-3 py-1 rounded-full text-sm font-medium ${config.bgColor} ${className}`}
    >
      {config.text}
    </span>
  );
};

export default UnitAvailableTag;
